export default __webpack_public_path__ + "static/media/shortest_go_live.19ad1d2b.png";